import React from 'react';
import styles from './headerLayout.module.css';
import ArtTherapyRegistration from './ArtTherapyRegistration';

const HeaderLayout = () => {
   const scrollToForm = () => {
    document.getElementById('pricing-section')?.scrollIntoView({ 
      behavior: 'smooth' 
    });
  };

  return (
    <div className={styles.eventContainer}>
      {/* Content Layout */}
      <div className={styles.contentLayout}>
        {/* Left Content - Intro */}
          {/* <div className={styles.leftContent}>
            <div className={styles.introSection}>
              <h2>Art Therapy Workshop – An Evening of Colors & Connections</h2>
              <h3>Why Join This Workshop?</h3>
              <p className={styles.introText}>
                This workshop isn't just about painting—it's about expressing yourself, 
                easing your heart, and finding people who truly get you.
              </p>
              <div className={styles.reassurance}>
                No art skills needed—all materials and refreshments are included.
              </div>

              <div className={styles.benefitsSection}>
                <h3>What You'll Experience</h3>
                <div className={styles.benefitsList}>
                  <div className={styles.benefitItem}>
                    <div className={styles.checkmark}>✓</div>
                    <span>A lighter heart & peaceful mind</span>
                  </div>
                  <div className={styles.benefitItem}>
                    <div className={styles.checkmark}>✓</div>
                    <span>Safe space to express yourself</span>
                  </div>
                  <div className={styles.benefitItem}>
                    <div className={styles.checkmark}>✓</div>
                    <span>Meaningful conversations & new friends</span>
                  </div>
                  <div className={styles.benefitItem}>
                    <div className={styles.checkmark}>✓</div>
                    <span>Boost of positivity & liveliness</span>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <ArtTherapyRegistration/>

        {/* Right Content */}
        <div className={styles.rightContent}>
          {/* Event Details Section */}
          <div className={styles.eventImageSection}>
            <div className={styles.eventImageContainer}>
              <div className={styles.imagePlaceholder}>
                <div className={styles.eventDetailsCard}>
                  <div className={styles.dateNumber}>6th</div>
                  <div className={styles.month}>December</div>
                  <div className={styles.time}>Time: 3 to 5 PM</div>
                  <div className={styles.venue}>Address:  The Artist House, Surajpole, Udaipur</div>
                </div>
              </div>
            </div>
            <div className={styles.eventImageContentContainer}>
              <h3>Workshop Details</h3>
              <p>Join us for an amazing evening of Colors, Conversations, and Connections</p>
            </div>
          </div>

          {/* Availability Section */}
          {/* <div className={styles.availabilitySection} id="pricing-section">
            <div className={styles.seatStatus}>
              <div className={styles.limitedSeatsMessage}>
                Limited Seats Book Now
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default HeaderLayout;